// استيراد hooks من React للتعامل مع الحالة والآثار الجانبية
import { useEffect, useState } from "react";
// استيراد كائن Axios المعد مسبقاً لإجراء طلبات HTTP
import { Axios } from "../../../../API/Axios";
// استيراد روابط API الخاصة بالأقسام والمنتجات
import { CATEGORIES, PRO } from "../../../../API/Api";
// استيراد مكون عرض الأقسام مع منتجاتها
import CategorySection from "./CategorySection";
// استيراد مكون الهيكل العظمي (Skeleton) أثناء التحميل
import Skeltonshow from "../../sekelton/skelton";
// استيراد Container من React-Bootstrap لإحاطة المحتوى
import { Container } from "react-bootstrap";

// تصدير المكون الرئيسي لعرض الأقسام مع منتجاتها
export default function CategoriesShowcase ()
{
    // حالة لتخزين قائمة الأقسام (الفئات) المسترجعة من API
    const [ categories, setCategories ] = useState( [] );
    // حالة لتخزين قائمة المنتجات المسترجعة من API
    const [ products, setProducts ] = useState( [] );
    // حالة لتحديد ما إذا كانت البيانات قيد التحميل
    const [ loading, setLoading ] = useState( true );

    // تأثير جانبي لجلب الأقسام والمنتجات من الخادم عند تحميل المكون
    useEffect( () =>
    {
        // استخدام Promise.all لإجراء طلبيتين متزامنتين في نفس الوقت
        // هذا أسرع من إجراء طلبين متتابعين
        Promise.all( [
            // الطلب الأول: جلب جميع الأقسام (الفئات)
            Axios.get( CATEGORIES ),
            // الطلب الثاني: جلب جميع المنتجات بدون تحديد حد أقصى
            // ملاحظة: بدون ?limit يعيد كل المنتجات (وليس آخر 6 فقط)
            Axios.get( `/${ PRO }` ),
        ] )
            .then( ( [ categoriesRes, productsRes ] ) =>
            {
                // تخزين الأقسام في الحالة
                setCategories( categoriesRes.data );

                // تصفية المنتجات: عرض المنتجات المنشورة فقط (published)
                // لأن API بدون limit يعيد جميع المنتجات حتى التي حالتها draft
                // نفلترها هنا لحماية المظهر العام وعدم عرض المنتجات غير المنشورة للزوار
                setProducts( productsRes.data.filter( ( p ) => p.status === 'published' ) );
            } )
            // في حالة حدوث خطأ، طباعته في وحدة التحكم للمساعدة في التصحيح
            .catch( ( error ) => console.log( "Error fetching categories/products:", error ) )
            // في جميع الأحوال (نجاح أو فشل)، إيقاف حالة التحميل
            .finally( () => setLoading( false ) );
    }, [] ); // تشغيل هذا التأثير مرة واحدة فقط عند تحميل المكون

    // إذا كانت البيانات لا تزال قيد التحميل، عرض هيكل عظمي (Skeleton) داخل Container
    if ( loading )
    {
        return (
            // إحاطة السكلتون بـ Container لتوحيد التباعد مع باقي المحتوى
            <Container>
                <div className="product-grid mt-5 mb-5">
                    {/* عرض 4 عناصر وهمية بارتفاع 300 بكسل كشاشة تحميل */ }
                    <Skeltonshow height="300px" length="4" />
                </div>
            </Container>
        );
    }

    // بعد تحميل البيانات، عرض الأقسام مع منتجاتها
    return (
        <>
            {/* التكرار على جميع الأقسام لعرض كل قسم مع منتجاته */ }
            { categories.map( ( cat ) =>
            {
                // فلترة المنتجات الخاصة بهذا القسم فقط
                // المقارنة: product.category === cat.id (المنتج ينتمي لهذا القسم)
                // استخدام 7 كحد أقصى لعرض المنتجات في كل قسم
                // حتى لو كان القسم يحتوي على 20 منتجاً، نعرض فقط أول 7
                // هذا يحافظ على جمالية التصميم ويمنع طول القسم بشكل مبالغ فيه
                const categoryProducts = products
                    .filter( ( product ) => product.category === cat.id )
                    .slice( 0, 7 );

                // إرجاع مكون CategorySection لكل قسم مع منتجاته المصفاة
                return (
                    <CategorySection
                        key={ cat.id } // مفتاح فريد لكل قسم (id القسم)
                        category={ cat } // تمرير بيانات القسم
                        products={ categoryProducts } // تمرير منتجات هذا القسم فقط (أول 7)
                    />
                );
            } ) }
        </>
    );
}